import { i18n } from '@/plugins/i18n'

export default [
    {
        field: 'shop_name',
        title: 'نام فروشگاه',
        width: 80,
        textAlign: 'center',
        template: (row) => {
            return `<p>${row.shop_name}</p>`
        },
    },
    {
        field: 'agent_acceptor',
        title: 'نام نماینده',
        width: 80,
        textAlign: 'center',
        template: (row) => {
            return `<a href="/users/${row.visitor.id}/details">${row.visitor.full_name}</a>`
        },
    },
    {
        field: 'visitor_acceptor',
        title: 'نام پذیرنده',
        width: 80,
        textAlign: 'center',
        template: (row) => {
            return `<a href="/users/${row.user.id}/details">${row.user.full_name}</a>`
        },
    },
    {
        field: 'period',
        title: 'دوره',
        width: 80,
        textAlign: 'center',
        template: (row) => {
            return `<p>${row.period}</p>`
        },
    },
    {
        field: 'acceptor_code',
        title: 'کد پذیرنده',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return `<p>${row.acceptor_code}</p>`
        },
    },
    {
        field: 'terminal_number',
        title: 'شماره ترمینال',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return `<p>${row.terminal_number}</p>`
        },
    },
    {
        field: 'transaction_count',
        title: 'تعداد تراکنش',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return `<p>${row.transaction_count}</p>`
        },
    },
    {
        field: 'total_amount',
        title: 'گردش کل (ریال)',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return `<p>${row.total_amount}</p>`
        },
    },
    {
        field: 'setting',
        title: i18n.t('transaction_routing.setting'),
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return '<a href="/change-agent/' + row.user.id + '/'+row.visitor.id+'/details"><span dir="ltr"><i class="fa fa-eye"></i></span></a>'
        },
    },
]